import { FilesKind, FilesMainKind } from '../Files'

export enum APPLICANT_KIND {
  'main' = 'main',
  'co_applicant' = 'co_applicant',
  'guarantor' = 'guarantor',
}

export interface RequiredUploadSubFiles {
  kind: FilesKind
  min: number
}
export interface RequiredUpload {
  kind: FilesMainKind
  required: RequiredUploadSubFiles[]
}

export interface Applicant {
  applicant_id: string
  duration?: string | undefined | null
  email?: string | undefined
  first_name?: string | undefined
  french_resident?: boolean | undefined
  has_guarantor?: boolean | undefined
  id: string
  guarantor_kind?: string | undefined
  probation?: boolean
  kind: APPLICANT_KIND
  last_name?: string | undefined
  phone_number?: string | undefined
  revenue?: string | undefined
  revenue_reference?: string | undefined
  situation?: string | undefined
  professional_situation?: string
  social_security_number?: string | undefined
  required_uploads?: RequiredUpload[]
  ratio?: number
  zip_link?: string | 'error' | ''
}
